module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-hero12.png?89add28e";